import { CtaBand, Footer, Header, ServicosPainel } from '../../molecules'

export function ServicosTemplate() {
  return (
    <>
      <Header />
      <ServicosPainel />
      <CtaBand />
      <Footer />
    </>
  )
}
